/* tslint:disable */
/* eslint-disable */
/**
 * RoadFootage.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 */
export const NotificationType = {
    ProcessingComplete: 'ProcessingComplete',
    ProcessingFailed: 'ProcessingFailed',
    ReportApproved: 'ReportApproved',
    ReportRejected: 'ReportRejected',
    BountyResponseReceived: 'BountyResponseReceived',
    DataExportReady: 'DataExportReady',
    BountyExtended: 'BountyExtended',
    BountyMatch: 'BountyMatch'
};
export function NotificationTypeFromJSON(json) {
    return NotificationTypeFromJSONTyped(json, false);
}
export function NotificationTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function NotificationTypeToJSON(value) {
    return value;
}
